import { makePromoSubmitAction } from 'state/promo/actions';
import { PromoDialogProps } from './types';
import { PromoForm } from 'forms/PromoForm/PromoForm';
import { useAction } from 'core/store/store';
import React, { useCallback } from 'react';
import i18n from '../../../../../i18n';
import { DialogNew } from '../../../../components/Dialog/DialogNew';

export const VendorPromoAddDialog = (props: PromoDialogProps) => {
    const { onClose } = props;
    const action = useAction();
    const { t } = i18n.useTranslation();
    const handleSubmit = useCallback((data: unknown) => action(makePromoSubmitAction, data), []);

    return (
        <DialogNew disableContentPadding title={t('vendor:promos.add.dialogTitle')} onClose={onClose}>
            <PromoForm onClose={onClose} onSubmit={handleSubmit} />
        </DialogNew>
    );
};
